<template>
  <div>
    <mdb-row class="my-3">
      <mdb-col md="2" class="col-label">기관</mdb-col>
      <mdb-col md="10">{{training.org.name}}</mdb-col>
    </mdb-row>
    <mdb-row class="my-3">
      <mdb-col md="2" class="col-label">NCS 훈련과정</mdb-col>
      <mdb-col md="10">{{training.ncsTraining}}</mdb-col>
    </mdb-row>
    <mdb-row class="my-3">
      <mdb-col md="2" class="col-label">개설과정명</mdb-col>
      <mdb-col md="10">{{training.name}}</mdb-col>
    </mdb-row>
    <mdb-row class="my-3">
      <mdb-col md="2" class="col-label">훈련차수</mdb-col>
      <mdb-col md="10">{{training.seq}}</mdb-col>
    </mdb-row>
    <mdb-row class="my-3">
      <mdb-col md="2" class="col-label">수준</mdb-col>
      <mdb-col md="10">{{training.level}}</mdb-col>
    </mdb-row>
    <mdb-row class="my-3">
      <mdb-col md="2" class="col-label">강사</mdb-col>
      <mdb-col md="10">{{training.teacher}}</mdb-col>
    </mdb-row>
    <mdb-row class="my-3">
      <mdb-col md="2" class="col-label">훈련대상</mdb-col>
      <mdb-col md="10">{{training.target}}</mdb-col>
    </mdb-row>
    <mdb-row class="my-3">
      <mdb-col md="2" class="col-label">기간</mdb-col>
      <mdb-col md="10">{{$strDate(training.startDate)}}~{{$strDate(training.endDate)}}</mdb-col>
    </mdb-row>
    <mdb-row class="my-3">
      <mdb-col md="2" class="col-label">과정 상태</mdb-col>
      <mdb-col md="10">{{training.status}}</mdb-col>
    </mdb-row>
  </div>
</template>
<script>
import { mdbRow, mdbCol } from 'mdbvue';
export default {
  name: 'TraingOverview',
  components: { mdbRow, mdbCol },
  props: ['training'],
  data: () => ({
    TAG: 'TraingOverview :'
  }),
  computed: {
  }
}
</script>
<style scoped>
.col-label {
  text-align: right;
  font-weight: 900;
}
</style>
